module.exports = __webpack_public_path__ + "img/Nitheesh_Balachandran.c4fd8f58.jpg";